import Modeling from 'diagram-js/lib/features/modeling/Modeling';
import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import { Shape } from 'diagram-js/lib/model';
import { ElementVisibilityHandler } from './handlers/element-visibility-handler';
import CommandStack from 'diagram-js/lib/command/CommandStack';
import { CommandType } from '@ispm/shared/bpmn-io/bpmn-js';
import { NodeNavigatorHandler } from '@ispm/shared/bpmn-io/handlers/node-navigator-handler';
import EventBus from 'diagram-js/lib/core/EventBus';
import { RenderElementHandler } from '@ispm/shared/bpmn-io/handlers/render-element-handler';
import { FloatingNodesHandler } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/floating-nodes-handler';
import { NodeNavigatorWithDataHandler } from '@ispm/shared/bpmn-io/handlers/node-navigator-with-data-handler';

export class PathwaysViewerCommands {
  constructor(protected eventBus: EventBus, protected elementFactory, protected commandStack: CommandStack) {
    this.eventBus.on('diagram.init', () => this.registerHandlers());
  }

  registerHandlers() {
    const handlerMap: Object = this.getHandlers();
    Object.keys(handlerMap).forEach(key => this.commandStack.registerHandler(key, handlerMap[key]));
  }

  getHandlers(): { [key: string]: CommandHandler } {
    const handlers = {};
    handlers[CommandType.SET_ELEMENT_VISIBILITY] = ElementVisibilityHandler;
    handlers[CommandType.NAVIGATE_TO_NODE] = NodeNavigatorHandler;
    handlers[CommandType.NAVIGATE_TO_NODE_WITH_DATA] = NodeNavigatorWithDataHandler;
    handlers[CommandType.RENDER_ELEMENT] = RenderElementHandler;
    handlers[CommandType.TOGGLE_FLOATING_NODES] = FloatingNodesHandler;
    return handlers;
  }

  public setElementVisibility(element: Shape, hidden: boolean) {
    this.commandStack.execute(CommandType.SET_ELEMENT_VISIBILITY, {element, hidden});
  }

  public renderElement(element: Shape) {
    this.commandStack.execute(CommandType.RENDER_ELEMENT, {element});
  }

  public navigateToNode(elementId: string, openPanel: boolean) {
    this.commandStack.execute(CommandType.NAVIGATE_TO_NODE, {elementId, openPanel});
  }

  public navigateToNodeWithData(elementId: string, openPanel: boolean, data:any) {
    this.commandStack.execute(CommandType.NAVIGATE_TO_NODE_WITH_DATA, {elementId, openPanel, data});
  }

  public toggleFloatingNodes(layer: string, hide: boolean) {
    const context = {layer: layer, hide: hide};
    this.commandStack.execute(CommandType.TOGGLE_FLOATING_NODES, context);
  }

}

PathwaysViewerCommands.$inject = [...Modeling.$inject];
